module.exports = __webpack_public_path__ + "static/car-pc/img/mile.53423c00.svg";